import React, { Suspense } from 'react';
import { Switch, BrowserRouter, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import ChatbotShell from './components/layout/ChatbotShell';
import { ADMIN_BASE_PATH } from './constants/adminPath';
import Home from './view/Home';
import NoticeListPage from './view/NoticeListPage';
import NoticeDetailPage from './view/NoticeDetailPage';

const AdminPage = React.lazy(() => import('./view/admin/AdminPage'));

// 404 페이지 컴포넌트 추가
// const NotFound = () => {
//   // 서버에 404 상태 코드를 전달하고 리다이렉트
//   React.useEffect(() => {
//     window.location.href = '/sejong-notfound.html';
//   }, []);
  
//   return <div>페이지를 찾을 수 없습니다. 리다이렉트 중...</div>;
// };

const Router = () => {
  // 개발 환경에서는 /aichat 경로를 테스트하기 위한 basename 설정
  const basename = process.env.PUBLIC_URL || '/';
  
  // console.log('Router initialized with basename:', basename);

  return (
    <BrowserRouter basename={basename}>
      <Switch>
        <Route path={ADMIN_BASE_PATH}>
          <Suspense fallback={<div style={{ padding: 24 }}>로딩 중…</div>}>
            <AdminPage />
          </Suspense>
        </Route>
        {/* 공지 — 챗봇 사이드바 유지 */}
        <Route path="/notices" exact>
          <ChatbotShell>
            <NoticeListPage />
          </ChatbotShell>
        </Route>
        <Route path="/notices/:noticeId" exact>
          <ChatbotShell>
            <NoticeDetailPage />
          </ChatbotShell>
        </Route>
        <Route>
          <Layout>
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/en" exact component={Home} />
              <Route path="/ja" exact component={Home} />
              <Route path="/cn" exact component={Home} />
              {/* 404 페이지 처리 추가 */}
              {/* <Route path="*" component={NotFound} /> */}
            </Switch>
          </Layout>
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
